export const getChoiceValues = (values) => {
  return Object.entries(values).filter(([key, value]) => value === true).map(([key, value]) => key)
}